export default __webpack_public_path__ + "static/media/bulgo-screenshot-06.83d466c4.png";